module.exports = __webpack_public_path__ + "static/img/66053J_X_5_6_7_20170525_LC.e87fdb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/66053J_X_5_6_7_20170525_LC.png
// module id = INrd
// module chunks = 0